<div
  class="load__header-info"
  [ngClass]="{
    'label-column': hasLabel,
    'speed-up-info-column': hasSpeedUpInfo,
    'no-label-column': !hasLabel,
    'no-speed-up-info-column': !hasSpeedUpInfo
  }"
>
  <ng-container *ngIf="hasLabel">
    <ng-container *ngIf="load.isCancelled; else deviationType">
      <span class="cancelled-label">{{ 'common.field.cancelled' | translate }} </span>
    </ng-container>

    <ng-template #deviationType>
      <ui-deviation-type *ngIf="load?.deviation as deviation" [deviation]="deviation"></ui-deviation-type>
    </ng-template>
  </ng-container>

  <div class="load__transport-mode">
    <ui-transport-mode [mode]="load?.transportMode" [showText]="false"></ui-transport-mode>
  </div>

  <div class="load__status" cropText>
    <ui-status-code
      [statusCode]="loadStatus?.statusCode"
      [statusDescription]="loadStatus?.statusDescription"
    ></ui-status-code>
  </div>

  <div class="load__carrier">
    <ui-svg-icon [name]="iconNameList.SteeringWheel"></ui-svg-icon>
    <span cropText>{{ load.carrierName ? load.carrierName : load.carrierId }}</span>
  </div>
  <ui-dates class="load__departure-time" cropText [dates]="load.dates" [dateType]="dateType.Departure"></ui-dates>
  <ui-dates class="load__arrival-time" cropText [dates]="load.dates" [dateType]="dateType.Arrival"></ui-dates>
  <div *ngIf="load.speedUpInformation">
    <ui-svg-icon [name]="iconNameList.SpeedometerSpeedHigh"></ui-svg-icon>
  </div>
</div>
